import { OwcButton } from '@one/react';
import { useTranslation } from 'core/i18n';
import { LoadErrorMessageComponent } from '../generic-error';
import { SearchErrorLayout } from './search-error.style';

interface SearchErrorComponentProps {
  onRetry: VoidFunction;
}

export const SearchErrorComponent: React.FC<SearchErrorComponentProps> = ({ onRetry }) => {
  const { t } = useTranslation('common');

  return (
    <SearchErrorLayout>
      <LoadErrorMessageComponent />
      <OwcButton variant="primary" onClick={onRetry}>
        {t('components.workflow-error.retry')}
      </OwcButton>
    </SearchErrorLayout>
  );
};
